// Canonical DockPro logo — served from the brand asset bucket (the same asset
// the embed's Powered-by badge uses). The portal CSP allows it via img-src https:.
export const DOCKPRO_LOGO_URL =
  "https://bluecrane-tenant-assets.s3.us-east-1.amazonaws.com/branding/_dockpro/logo-gradient.png";
